import { get, isNil } from 'lodash';

export const cacheFn = (fn: () => any, duration: number) => {
  let cache: { current?: any; lastCall: number } = {
    lastCall: 0,
  };

  const replaceCurrent = () => {
    // for async functions, we cache the promise itself not the result
    cache = {
      current: fn(),
      lastCall: Date.now(),
    };
  };

  return async (options?: { ignoreCache: boolean }): Promise<any> => {
    if (get(options, 'ignoreCache', false)) {
      replaceCurrent();
    } else {
      const diff = Date.now() - cache.lastCall;
      if (isNil(get(cache, 'current')) || diff >= duration) {
        replaceCurrent();
      }
    }

    return get(cache, 'current');
  };
};
